/* tslint:disable */
/* eslint-disable */
/**
 * DexIt
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { ReleaseOfInformationRequestModel } from '../Models';
// @ts-ignore
import { ReleaseOfInformationResponseModel } from '../Models';
// @ts-ignore
import { ReleaseOfInformationSearchModel } from '../Models';
// @ts-ignore
import { ResponseModel } from '../Models';
/**
 * ReleaseOfInformationApi - axios parameter creator
 * @export
 */
export const ReleaseOfInformationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ReleaseOfInformationSearchModel} releaseOfInformationSearchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllReleaseOfInformation: async (releaseOfInformationSearchModel: ReleaseOfInformationSearchModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'releaseOfInformationSearchModel' is not null or undefined
            assertParamExists('getAllReleaseOfInformation', 'releaseOfInformationSearchModel', releaseOfInformationSearchModel)
            const localVarPath = `/api/v1/releaseOfInformation/getAllReleaseOfInformation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(releaseOfInformationSearchModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReleaseOfInformationRequestModel} releaseOfInformationRequestModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitReleaseOfInformationRequest: async (releaseOfInformationRequestModel: ReleaseOfInformationRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'releaseOfInformationRequestModel' is not null or undefined
            assertParamExists('submitReleaseOfInformationRequest', 'releaseOfInformationRequestModel', releaseOfInformationRequestModel)
            const localVarPath = `/api/v1/releaseOfInformation/submitReleaseOfInformationRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(releaseOfInformationRequestModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReleaseOfInformationApi - functional programming interface
 * @export
 */
export const ReleaseOfInformationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReleaseOfInformationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ReleaseOfInformationSearchModel} releaseOfInformationSearchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllReleaseOfInformation(releaseOfInformationSearchModel: ReleaseOfInformationSearchModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReleaseOfInformationResponseModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllReleaseOfInformation(releaseOfInformationSearchModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReleaseOfInformationApi.getAllReleaseOfInformation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ReleaseOfInformationRequestModel} releaseOfInformationRequestModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitReleaseOfInformationRequest(releaseOfInformationRequestModel: ReleaseOfInformationRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitReleaseOfInformationRequest(releaseOfInformationRequestModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReleaseOfInformationApi.submitReleaseOfInformationRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReleaseOfInformationApi - factory interface
 * @export
 */
export const ReleaseOfInformationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReleaseOfInformationApiFp(configuration)
    return {
        /**
         * 
         * @param {ReleaseOfInformationSearchModel} releaseOfInformationSearchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllReleaseOfInformation(releaseOfInformationSearchModel: ReleaseOfInformationSearchModel, options?: any): AxiosPromise<Array<ReleaseOfInformationResponseModel>> {
            return localVarFp.getAllReleaseOfInformation(releaseOfInformationSearchModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReleaseOfInformationRequestModel} releaseOfInformationRequestModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitReleaseOfInformationRequest(releaseOfInformationRequestModel: ReleaseOfInformationRequestModel, options?: any): AxiosPromise<ResponseModel> {
            return localVarFp.submitReleaseOfInformationRequest(releaseOfInformationRequestModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReleaseOfInformationApi - interface
 * @export
 * @interface ReleaseOfInformationApi
 */
export interface ReleaseOfInformationApiInterface {
    /**
     * 
     * @param {ReleaseOfInformationSearchModel} releaseOfInformationSearchModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReleaseOfInformationApiInterface
     */
    getAllReleaseOfInformation(releaseOfInformationSearchModel: ReleaseOfInformationSearchModel, options?: RawAxiosRequestConfig): AxiosPromise<Array<ReleaseOfInformationResponseModel>>;

    /**
     * 
     * @param {ReleaseOfInformationRequestModel} releaseOfInformationRequestModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReleaseOfInformationApiInterface
     */
    submitReleaseOfInformationRequest(releaseOfInformationRequestModel: ReleaseOfInformationRequestModel, options?: RawAxiosRequestConfig): AxiosPromise<ResponseModel>;

}

/**
 * ReleaseOfInformationApi - object-oriented interface
 * @export
 * @class ReleaseOfInformationApi
 * @extends {BaseAPI}
 */
export class ReleaseOfInformationApi extends BaseAPI implements ReleaseOfInformationApiInterface {
    /**
     * 
     * @param {ReleaseOfInformationSearchModel} releaseOfInformationSearchModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReleaseOfInformationApi
     */
    public getAllReleaseOfInformation(releaseOfInformationSearchModel: ReleaseOfInformationSearchModel, options?: RawAxiosRequestConfig) {
        return ReleaseOfInformationApiFp(this.configuration).getAllReleaseOfInformation(releaseOfInformationSearchModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReleaseOfInformationRequestModel} releaseOfInformationRequestModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReleaseOfInformationApi
     */
    public submitReleaseOfInformationRequest(releaseOfInformationRequestModel: ReleaseOfInformationRequestModel, options?: RawAxiosRequestConfig) {
        return ReleaseOfInformationApiFp(this.configuration).submitReleaseOfInformationRequest(releaseOfInformationRequestModel, options).then((request) => request(this.axios, this.basePath));
    }
}

